import { auth, facebookAuthProvider } from '../../constants/firebase';
import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';

class LoggedIn extends Component {
  static propTypes = {
    match: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
    seethrough: PropTypes.bool
  };

  handleLogin = async () => {
    await auth
      .signInWithRedirect(facebookAuthProvider)
      .catch(error => console.error('error', error));
    this.props.history.push('/home');
  };

  render() {
    return (
      <button
        data-test="login"
        className={`tr bn underline f5 pointer ttu small-caps 
        ${this.props.seethrough && 'seethrough b'}`}
        style={{ textDecorationSkip: 'ink' }}
        onClick={() => this.handleLogin()}
      >
        {this.props.title}
      </button>
    );
  }
}

export default withRouter(LoggedIn);



// WEBPACK FOOTER //
// ./src/components/Navigation/AuthButtons.js